import { render, staticRenderFns } from "./otherHistory.vue?vue&type=template&id=149c4a52"
import script from "./otherHistory.vue?vue&type=script&lang=js"
export * from "./otherHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports